import React from 'react';
import Login, { Render } from 'react-login-page';
import Logo from 'react-login-page/logo-rect';
import {signinWithGoogle, googleSignOut} from '../../services/firebase/index';

import {useAuth} from '../../context/authContext';
import {CustomerServiceContext } from '../../context/customer';
import { Customer } from '../../providers/customer/types';
import { CustomerAtom } from '../../atoms/customerAtom';
import { useRecoilState } from 'recoil';

import { useAsyncFn } from '../../hooks/useAsync';
import { log } from 'console';
import { useTheme } from '../../context/ThemeContext';

export const SignUpPage = () => {
  
  const {user,userLogin,loading } = useAuth();
    const [isSIgnedIn, setIsSignedIn] = React.useState(userLogin);
  const [customer, setCustomer] = useRecoilState(CustomerAtom);
  const { isDarkMode } = useTheme();

  const customerService = React.useContext(CustomerServiceContext);

  const [googleSignInState, googleSignIn] = useAsyncFn(async() => {
    return   signinWithGoogle();
  })


  const [createCustomerState, createCustomer] = useAsyncFn(async(c1: Customer) => {
    return await customerService.createCustomer(c1);
  });


  const handleGoogleLogin = async() => {
    
      console.log('google login');
      
      try {
        const logindata = await googleSignIn();
        
        const c1: Customer = {
          email: logindata.user.email as string,
          username: logindata.user.displayName as string,
          thirdPartyType: logindata.user.providerData[0].providerId as string,
          thirdPartyId: logindata.user.providerData[0].uid as string,
          password: 'temp',
          thirdPartyToken: logindata.user.uid as string,
          profile_image: logindata.user.photoURL as string,
        };
        await createCustomer(c1);
        setIsSignedIn(true);
      } catch (error) {
        console.log(error);
        // googleSignOut();

      }
  
     
    }

    if (createCustomerState.error) {
      console.log(createCustomerState.error);
      if (createCustomerState.error === 'Failed to create customer') {
        window.location.href = '#/profile';
      }
    }

    if ( isSIgnedIn) {
      window.location.href = '#/profile';
    }
  

    return (
        <>
          
          <div className={`flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8 ${isDarkMode ? 'bg-gray-900' : 'bg-white'}`}>
            <div className="sm:mx-auto sm:w-full sm:max-w-sm">
              {/* <img
                alt="Your Company"
                src="https://tailwindui.com/plus/img/logos/mark.svg?color=indigo&shade=600"
                className="mx-auto h-10 w-auto"
              /> */}
              <h2 className={`mt-10 text-center text-2xl/9 font-bold tracking-tight ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                Create your account
              </h2>
            </div>
    
            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
              <form action="#" method="POST" className="space-y-6">
                <div>
                  <label htmlFor="email" className={`block text-sm/6 font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                    Email address
                  </label>
                  <div className="mt-2">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      required
                      autoComplete="email"
                      className={`block w-full rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-accent-primary sm:text-sm/6 ${
                        isDarkMode 
                          ? 'bg-gray-800 text-white outline-gray-700' 
                          : 'bg-white text-gray-900 outline-gray-300'
                      }`}
                    />
                  </div>
                </div>
    
                <div>
                  <div className="flex items-center justify-between">
                    <label htmlFor="password" className={`block text-sm/6 font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                      Password
                    </label>
                  </div>
                  <div className="mt-2">
                    <input
                      id="password"
                      name="password"
                      type="password"
                      placeholder='input password'
                      required
                      autoComplete="input-password"
                      className={`block w-full rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-accent-primary sm:text-sm/6 ${
                        isDarkMode 
                          ? 'bg-gray-800 text-white outline-gray-700' 
                          : 'bg-white text-gray-900 outline-gray-300'
                      }`}
                    />
                  </div>
                </div>

                <div>
                  <div className="flex items-center justify-between">
                    <label htmlFor="password" className={`block text-sm/6 font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                      Confirm Password
                    </label>
                    
                  </div>
                  <div className="mt-2">
                    <input
                      id="password"
                      name="password"
                      type="password"
                      placeholder='confirm password'
                      required
                      autoComplete="confirm-password"
                      className={`block w-full rounded-md px-3 py-1.5 text-base outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-accent-primary sm:text-sm/6 ${
                        isDarkMode 
                          ? 'bg-gray-800 text-white outline-gray-700' 
                          : 'bg-white text-gray-900 outline-gray-300'
                      }`}
                    />
                  </div>
                </div>
    
                <div>
                  <button
                    type="submit"
                    className="flex w-full justify-center rounded-md bg-accent-primary px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-accent-primary-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-primary"
                  >
                    Sign up
                  </button>
                </div>
              </form>


              <div className="relative mt-6">
                <div className="absolute inset-0 flex items-center">
                  <div className={`w-full border-t ${isDarkMode ? 'border-gray-700' : 'border-gray-300'}`} />
                </div>
                <div className="relative flex justify-center text-sm">
                  <span className={`px-2 ${isDarkMode ? 'bg-gray-900 text-gray-400' : 'bg-white text-gray-500'}`}>or</span>
                </div>
                </div>

                <div className="mt-6">
                  <button
                  onClick={handleGoogleLogin}
                  type="button"
                  className="flex w-full justify-center rounded-md bg-gray-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
                  >
                  Sign in with Google
                  </button>
                </div>

    
              <p className={`mt-10 text-center text-sm/6 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                Already a member?{' '}
                <a href="#/login" className="font-semibold text-accent-primary hover:text-accent-primary-dark">
                  Login
                </a>
              </p>
            </div>
          </div>
        </>
      )
    



};